module.exports = __webpack_public_path__ + "img/product_4.e82ad0c.jpg";